module.exports = __webpack_public_path__ + "img/wakanda.91f75127.png";